import React, { Component } from "react";
import { App } from "../../App";
import { AppScreen } from "../../AppScreen";
import { CloseButton } from "../components/CloseButton";
import { ColourIn } from "../../modules/ColourIn";
import { ColourItemSlider } from "./components/ColourItemSlider";
import { ColourMeScene, ColourSceneSelect } from "./ColourSceneSelectScreen";

export interface ColourMeScreenProps
{
}

interface ColourMeScreenState 
{
    screen: Screen;
    sceneReady: boolean;
    svgSrc: string;
}

enum Screen 
{
    Selection,
    ColourIn
}

export class ColourMeScreen extends Component<ColourMeScreenProps, ColourMeScreenState>
{
    private sceneRef: React.RefObject<HTMLDivElement>;
    private imageSrc: React.RefObject<HTMLImageElement>;
    private colourIn: ColourIn;

    constructor(props: ColourMeScreenProps)
    {
        super(props);

        this.sceneRef = React.createRef();
        this.imageSrc = React.createRef();

        this.state = {
            screen: Screen.Selection,
            sceneReady: false,
            svgSrc: null
        };
    }

    public componentDidMount(): void
    {
        this.onLoadSelection();
    }

    private onLoadSelection(): void 
    {
        document.body.classList.add("colour-selection");
        document.body.classList.remove("colour-in");

        this.setState({
            screen: Screen.Selection,
            sceneReady: false
        });
    }

    private onLoadColourIn(colourMeInSvg: string): void 
    {
        document.body.classList.add("colour-in");
        document.body.classList.remove("colour-selection");

        this.setState({
            screen: Screen.ColourIn,
        },
            () => this.onInitColourInModule(colourMeInSvg)
        );
    }

    private onInitColourInModule(colourMeInSvg: string): void 
    {
        this.colourIn = new ColourIn(
            this.sceneRef.current,
            colourMeInSvg
        );

        this.setState({
            sceneReady: true
        });
    }

    private onCloseClicked(): void 
    {
        if (this.state.screen === Screen.Selection)
        {
            App.I.changeScreen(AppScreen.Landing);
        }
        else 
        {
            this.onLoadSelection();
        }
    }

    private onSceneClicked(scene: ColourMeScene): void 
    {
        this.onLoadColourIn(scene.scene);
    }

    private onReady(): void 
    {
        this.setState({
            screen: Screen.ColourIn
        });
    }

    private onColorChanged(color: string): void 
    {
        this.colourIn.setColour(color);
    }

    private onDownloadSceneClicked(): void 
    {
        this.colourIn.download();
    }

    private onUndoClicked(): void 
    {
        this.colourIn.undo();
    }

    public render(): JSX.Element
    {
        return (
            <>
                <CloseButton onClicked={this.onCloseClicked.bind(this)} />

                {this.state.screen === Screen.ColourIn ?
                    <button className="btn btn-text" onClick={() => App.I.changeScreen(AppScreen.Landing)}>
                        Choose another page <i className="bi bi-chevron-right ps-1"></i>
                    </button>
                    : null
                }

                {this.state.screen === Screen.ColourIn
                    ?
                    <>
                        <div className="colour-me-screen colour-in">

                            <div className="container">
                                <div className="colour-me-container">

                                    <div id="scene" className="scene mt-2 mb-2 ml-auto mr-auto" ref={this.sceneRef}>
                                    </div>

                                    <p className="text-center">
                                        Choose a colour and tap the image
                                    </p>

                                    {this.state.sceneReady ?
                                        <div className="scene-colours mb-3">
                                            <ColourItemSlider onColorChanged={this.onColorChanged.bind(this)} />
                                        </div>
                                        : null
                                    }

                                    <div className="d-flex mt-auto btn-container mt-2 mb-2">
                                        <button className="btn btn-primary btn-icon-column btn-lg w-45" onClick={this.onUndoClicked.bind(this)} title="Undo">
                                            <span className="icon icon-undo"></span>
                                            Undo
                                        </button>
                                        <button className="btn btn-primary btn-icon-column btn-lg w-45" onClick={this.onDownloadSceneClicked.bind(this)} title="Download">
                                            <span className="icon icon-download"></span>
                                            Download
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div >
                    </>
                    :
                    <ColourSceneSelect onSceneClicked={this.onSceneClicked.bind(this)} />
                }
            </>
        );
    }

    public componentWillUnmount(): void
    {
        this.colourIn = null;
    }
}